// The durable material a transcript entry names, if any — a pure projection
// over the chat transcript.

import type { ChatEntry } from "../../components/Chat/types.js";

// A live build card that SETTLED already names its durable material (the
// `build_settled` echo of `material_created`), so it counts the same as the
// pointer card the reload projects: the right dock shows the material the
// moment it exists, not only after the turn-end re-read (live == reload).
export const materialIdOf = (entry: ChatEntry): string | undefined =>
    entry.type === "material"
        ? entry.materialId
        : entry.type === "material_building" && entry.build.status === "settled"
          ? entry.build.materialId
          : undefined;
